import React from 'react';
import './QuestionLoading.css';

const Skeleton = ({ className = '' }) => <span className={`qq-skeleton ${className}`} />;

const QuestionLoading = ({ variant = 'reader', label = 'Chargement de la question' }) => (
  <div className={`qq-loading qq-loading-${variant}`} role="status" aria-label={label}>
    <div className="qq-loading-message">
      <div className="bam-loading-mark" aria-hidden="true">
        <span />
        <span />
        <span />
        <span />
      </div>
      <div>
        <strong>{label}</strong>
        <span>Votre espace se prépare…</span>
      </div>
    </div>
    <div className="qq-loading-preview" aria-hidden="true">
      {variant === 'list' ? (
        [0, 1, 2, 3].map(index => (
          <div className="qq-skeleton-ticket" key={index}>
            <Skeleton className="qq-skeleton-short" />
            <Skeleton />
            <Skeleton className="qq-skeleton-medium" />
            <div className="qq-skeleton-author">
              <Skeleton className="qq-skeleton-avatar" />
              <Skeleton className="qq-skeleton-short" />
            </div>
          </div>
        ))
      ) : (
        <>
          <div className="qq-skeleton-author">
            <Skeleton className="qq-skeleton-avatar" />
            <Skeleton className="qq-skeleton-short" />
          </div>
          <Skeleton className="qq-skeleton-title" />
          <Skeleton className="qq-skeleton-medium qq-skeleton-title" />
          <div className="qq-skeleton-editor">
            <Skeleton className="qq-skeleton-short" />
            <Skeleton />
            <Skeleton className="qq-skeleton-medium" />
            <Skeleton className="qq-skeleton-button" />
          </div>
        </>
      )}
    </div>
  </div>
);

export default QuestionLoading;
